import styled from 'styled-components';
import Typography from 'components/Typography';

export const Text = styled(Typography)`
  margin: ${({ theme }) => theme.spacing.xs};
`;

export const StyledContainer = styled.div<{
  background: string;
}>`
  z-index: ${({ theme }) => theme._ui.chatPanel.zIndex + 1};
  min-width: ${({ theme }) => theme.spacing.xl};
  width: min-content;
  height: ${({ theme }) => theme.spacing.xl};

  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  right: 0;
  top: -2px;

  border-radius: ${({ theme }) => theme.borderRadius.round};
  outline: ${({ theme }) => theme.border.sm} solid ${({ theme }) => theme.text.inverse};

  background: ${({ background }) => background};

  color: ${({ theme }) => theme.text.inverse};
`;
